// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-white: #fff;
    --primary-black: #000;
    --primary-grey: #73739a;
    --primary-grey2: #fffc;
    --primary-blue: #6d72f6;
    --primary-green: #08ce8a;
    --primary-black2: #1c1c57;
}

.AboutHero-sectiion {
    position:relative;
}

.AboutHero-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    overflow: hidden;
    min-height: 1183px;
    inset: -130px 0 auto;
}
  
.AboutHero-bg img {
    max-width: 67%;
    transition: transform 0.5s ease-in-out;
}
  
.AboutHero-sectiion:hover .AboutHero-bg img {
    transform: scale(1.05); 
}

.AboutHero-main-container {
    height: 55vh;
    display: flex;
    text-align:center;
    position: relative;
    align-items: center;
    justify-content: center;
}

.AboutHero-title-box {
    animation: fadeInUp 1.5s ease-out;
}

.AboutHero-title-box h4 {
    font-size: 14px;
    margin-bottom: 20px;
    color: var(--primary-grey);
    animation: fadeIn 1s ease-in-out;
}

.AboutHero-title-box h1 {
    width: 100%;
    font-size: 46px;
    max-width: 750px;
    color: var(--primary-black2);
    animation: fadeInUp 2s ease-in-out;
}

.AboutHero-title-box h1 span {
    color: var(--primary-blue);
}

/* Animations */
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 480px) {
    .AboutHero-title-box h1 {
        font-size: 28px;
        padding: 0 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/AboutHero/AboutHero.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;AACJ","sourcesContent":[":root {\n    --primary-white: #fff;\n    --primary-black: #000;\n    --primary-grey: #73739a;\n    --primary-grey2: #fffc;\n    --primary-blue: #6d72f6;\n    --primary-green: #08ce8a;\n    --primary-black2: #1c1c57;\n}\n\n.AboutHero-sectiion {\n    position:relative;\n}\n\n.AboutHero-bg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    overflow: hidden;\n    min-height: 1183px;\n    inset: -130px 0 auto;\n}\n  \n.AboutHero-bg img {\n    max-width: 67%;\n    transition: transform 0.5s ease-in-out;\n}\n  \n.AboutHero-sectiion:hover .AboutHero-bg img {\n    transform: scale(1.05); \n}\n\n.AboutHero-main-container {\n    height: 55vh;\n    display: flex;\n    text-align:center;\n    position: relative;\n    align-items: center;\n    justify-content: center;\n}\n\n.AboutHero-title-box {\n    animation: fadeInUp 1.5s ease-out;\n}\n\n.AboutHero-title-box h4 {\n    font-size: 14px;\n    margin-bottom: 20px;\n    color: var(--primary-grey);\n    animation: fadeIn 1s ease-in-out;\n}\n\n.AboutHero-title-box h1 {\n    width: 100%;\n    font-size: 46px;\n    max-width: 750px;\n    color: var(--primary-black2);\n    animation: fadeInUp 2s ease-in-out;\n}\n\n.AboutHero-title-box h1 span {\n    color: var(--primary-blue);\n}\n\n/* Animations */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (max-width: 480px) {\n    .AboutHero-title-box h1 {\n        font-size: 28px;\n        padding: 0 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
